import React from 'react';
import DatePicker from 'react-date-picker';
import { FaRegCalendarAlt, FaRedo } from "react-icons/fa";

// Format Date to dd/mm/yyyy string
const formatDate = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

// Parse multiple date formats safely to Date
const parseDate = (input) => {
    if (!input) return null;

    if (input instanceof Date && !isNaN(input)) {
        return input;
    }

    if (typeof input !== 'string') return null;

    // Handle ISO string
    const isoParsed = new Date(input);
    if (!isNaN(isoParsed)) return isoParsed;

    // Handle dd/mm/yyyy
    if (input.includes('/')) {
        const [dd, mm, yyyy] = input.split('/');
        const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        if (!isNaN(date)) return date;
    }

    // Handle yyyy-mm-dd
    if (input.includes('-')) {
        const [yyyy, mm, dd] = input.split('-');
        const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        if (!isNaN(date)) return date;
    }

    return null; // fallback
};

const DateFild = ({ value, onChange }) => {
    const parsedDate = parseDate(value);

    const handleChange = (dateObj) => {
        const formatted = formatDate(dateObj);
        onChange(formatted); // Always return dd/mm/yyyy
    };

    return (
        <DatePicker
            onChange={handleChange}
            value={parsedDate}
            format="dd/MM/yyyy"
            clearIcon={<FaRedo />}
            calendarIcon={<FaRegCalendarAlt />}
            dayPlaceholder="dd"
            monthPlaceholder="mm"
            yearPlaceholder="yyyy"
        />
    );
};

export default DateFild;
